import React from 'react';
import Description from '../Description/Description';
import AuthorInfo from '../AuthorInfo/AuthorInfo';
import Buttons from '../Buttons/Buttons';

import './ResultContainer.css';
import BadgeContainer from '../BadgeContainer/BadgeContainer';

const ResultContainer = ({ result, decodeHtmlEntities, onClickLink }) => {
  const fileType = result.file_type?.raw || '';
  const resourceType = result.resource_type?.raw || '';
  const resultType = result.result_type?.raw || '';
  const url = result.url?.raw || '';

  return (
    <div className="result-container">
      <Description 
        metaDescription={result.meta_description?.snippet || ''} 
        decodeHtmlEntities={decodeHtmlEntities} 
      />
      
      <AuthorInfo 
        resultType={resultType} 
        blogAuthor={result.blog_author?.raw || ''} 
        blogPublishedString={result.blog_published_string?.raw || ''} 
      />
      
      <Buttons 
        fileType={fileType} 
        resourceType={resourceType} 
        resultType={resultType} 
        url={url} 
        onClickLink={onClickLink} 
      />
      <BadgeContainer 
              resourceType={resourceType} 
              fileType={fileType} 
              resultType={resultType} 
            />
      </div>
  );
};

export default ResultContainer;
